<template>
  <section id="Contatos" class="section-item">
    <h1>{{ $t("title.contacts") }}</h1>

    <section id="api-Contatos-PutContactsId">
      <h2>{{ $t("title.contacts") }} - {{ $t("title.update_contact") }}</h2>
      <p>
        {{ $t("contacts.update_contact_by_id_method") }}
      </p>
      <div class="">
        <div class="put type">PUT</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/contacts/:id</code></pre>
      </div>
      <div class="code-toggle">
        <button
          @click="selectedTab = 'json'"
          :class="{ active: selectedTab === 'json' }"
        >
          JSON
        </button>
        <button
          @click="selectedTab = 'curl'"
          :class="{ active: selectedTab === 'curl' }"
        >
          cURL
        </button>
      </div>

      <pre v-if="selectedTab === 'curl'">
          <code class="language-bash">curl -XPOST -H "Content-type: application/json" -d '{"first_name":"Lucas","last_name":"Lima","mobile_number":"997423162","email":"email@mail.com","groups":[]}' 'https://{{ whitelabel?.api_domain }}/v1/contacts/:id'
-u '[SEU ID]:[SEU TOKEN]'</code>
        </pre>

      <pre v-if="selectedTab === 'json'">
          <code class="language-json">{   
   "first_name":"Lucas",
   "last_name":"Lima",
   "mobile_number":"997423162",
   "email":"email@mail.com",
   "groups":[]
}</code>
        </pre>

      <h3>{{ $t("general.header") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Content-Type</td>
            <td>String</td>
            <td>
              {{ $t("general.default_value") }}
              <span class="app-json">application/json</span>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.contact_id") }}</td>
          </tr>
          <tr>
            <td>first_name</td>
            <td>String</td>
            <td>{{ $t("table.first_name") }}</td>
          </tr>
          <tr>
            <td>last_name</td>
            <td>String</td>
            <td>{{ $t("table.last_name") }}</td>
          </tr>
          <tr>
            <td>mobile_number</td>
            <td>String</td>
            <td>{{ $t("table.mobile_number") }}</td>
          </tr>
          <tr>
            <td>email</td>
            <td>String</td>
            <td>{{ $t("table.email") }}</td>
          </tr>
          <tr>
            <td>groups</td>
            <td>Array</td>
            <td>{{ $t("table.groups") }}</td>
          </tr>
        </tbody>
      </table>

      <h3>Success 200</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.contact_id_create") }}</td>
          </tr>
          <tr>
            <td>first_name</td>
            <td>String</td>
            <td>{{ $t("table.first_name_must") }}</td>
          </tr>
          <tr>
            <td>last_name</td>
            <td>String</td>
            <td>{{ $t("table.last_name_must") }}</td>
          </tr>
          <tr>
            <td>birthdate</td>
            <td>String</td>
            <td>{{ $t("table.birthdate") }}</td>
          </tr>
          <tr>
            <td>mobile_number</td>
            <td>String</td>
            <td>{{ $t("table.mobile_number_must") }}</td>
          </tr>
          <tr>
            <td>email</td>
            <td>String</td>
            <td>{{ $t("table.email_must") }}</td>
          </tr>
          <tr>
            <td>gender</td>
            <td>String</td>
            <td>{{ $t("table.gender") }}</td>
          </tr>
          <tr>
            <td>city</td>
            <td>String</td>
            <td>{{ $t("table.city") }}</td>
          </tr>
          <tr>
            <td>country</td>
            <td>String</td>
            <td>{{ $t("table.country") }}</td>
          </tr>
          <tr>
            <td>description</td>
            <td>String</td>
            <td>{{ $t("table.description") }}</td>
          </tr>
          <tr>
            <td>account_id</td>
            <td>String</td>
            <td>{{ $t("account.account_id") }}</td>
          </tr>
          <tr>
            <td>created_at</td>
            <td>String</td>
            <td>{{ $t("table.created_at") }}</td>
          </tr>
          <tr>
            <td>updated_at</td>
            <td>String</td>
            <td>{{ $t("table.updated_at") }}</td>
          </tr>
          <tr>
            <td>groups</td>
            <td>Array</td>
            <td>{{ $t("table.groups_must") }}</td>
          </tr>
        </tbody>
      </table>

      <button class="btn02">{{ $t("general.success") }}</button>

      <pre>
          <code class="language-json">HTTP/1.1 200 OK
{
  "id": "de912c73-77aa-4b54-8c31-91c34a6966aa",
  "first_name": "V",
  "last_name": "M",
  "birthdate": null,
  "mobile_number": "5538999628692",
  "email": "contato@victormartins.me",
  "gender": null,
  "city": null,
  "country": null,
  "description": null,
  "account_id": "d811ae1c-b079-45be-bec6-a659f2462e29",
  "created_at": "2020-11-24T15:37:37.000000Z",
  "updated_at": "2020-11-24T15:37:37.000000Z",
  "groups": []
}</code>
        </pre>

      <button class="btn02">Error-Response</button>
      <pre>
          <code class="language-json">{
    "error": "Error message"
}</code>
        </pre>
    </section>

    <section id="api-Contatos-PostContacts">
      <h2>{{ $t("title.contacts") }} - {{ $t("title.create_contact") }}</h2>
      <p>{{ $t("contacts.create_contact_method") }}</p>
      <div class="">
        <div class="post type">POST</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/contacts</code></pre>
      </div>
      <div class="code-toggle">
        <button
          @click="selectedTab = 'json'"
          :class="{ active: selectedTab === 'json' }"
        >
          JSON
        </button>
        <button
          @click="selectedTab = 'curl'"
          :class="{ active: selectedTab === 'curl' }"
        >
          cURL
        </button>
      </div>

      <pre v-if="selectedTab === 'curl'">
          <code class="language-bash">curl -XPOST -H "Content-type: application/json" -d '{"first_name":"Lucas","last_name":"Lima","mobile_number":"997423162","email":"email@mail.com","groups":[]}' 'https://{{ whitelabel?.api_domain }}/v1/contacts'
-u '[SEU ID]:[SEU TOKEN]'</code>
        </pre>

      <pre v-if="selectedTab === 'json'">
          <code class="language-json">{   
   "first_name":"Lucas",
   "last_name":"Lima",
   "mobile_number":"997423162",
   "email":"email@mail.com",
   "groups":[]
}</code>
        </pre>

      <h3>{{ $t("general.header") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Content-Type</td>
            <td>String</td>
            <td>
              {{ $t("general.default_value") }}
              <span class="app-json">application/json</span>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>first_name</td>
            <td>String</td>
            <td>{{ $t("table.first_name_must") }}</td>
          </tr>
          <tr>
            <td>last_name</td>
            <td>String</td>
            <td>{{ $t("table.last_name_must") }}</td>
          </tr>
          <tr>
            <td>mobile_number</td>
            <td>String</td>
            <td>{{ $t("table.mobile_number_must") }}</td>
          </tr>
          <tr>
            <td>email</td>
            <td>String</td>
            <td>{{ $t("table.email_must") }}</td>
          </tr>
          <tr>
            <td>groups</td>
            <td>Array</td>
            <td>{{ $t("table.contact_group_ids") }}</td>
          </tr>
        </tbody>
      </table>

      <h3>Success 200</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>first_name</td>
            <td>String</td>
            <td>{{ $t("table.first_name_must") }}</td>
          </tr>
          <tr>
            <td>last_name</td>
            <td>String</td>
            <td>{{ $t("table.last_name_must") }}</td>
          </tr>
          <tr>
            <td>mobile_number</td>
            <td>String</td>
            <td>{{ $t("table.contact_mobile_number_created") }}</td>
          </tr>
          <tr>
            <td>email</td>
            <td>String</td>
            <td>{{ $t("table.email_must") }}</td>
          </tr>
          <tr>
            <td>account_id</td>
            <td>String</td>
            <td>{{ $t("table.account_id_create") }}</td>
          </tr>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.contact_id_create") }}</td>
          </tr>
          <tr>
            <td>created_at</td>
            <td>String</td>
            <td>{{ $t("table.created_at") }}</td>
          </tr>
          <tr>
            <td>updated_at</td>
            <td>String</td>
            <td>{{ $t("table.updated_at") }}</td>
          </tr>
        </tbody>
      </table>

      <button class="btn02">{{ $t("general.success") }}</button>

      <pre>
          <code class="language-json">HTTP/1.1 200 OK
{
   "first_name":"Nome",
   "last_name":"Sobrenome",
   "mobile_number":"999999999",
   "email":"email@mail.com",
   "account_id":"f98c24gd-8239-4c4f-a2e8-143f26820f58",
   "id":"3164512a-6f4a-46ff-9cdd-e14607001ad8",
   "updated_at":"2020-08-04T13:29:58.000000Z",
   "created_at":"2020-08-04T13:29:58.000000Z"
}</code>
        </pre>

      <button class="btn02">Error-Response</button>
      <pre>
          <code class="language-json">{
    "error": "Error message"
  }</code>
        </pre>
    </section>

    <section id="api-Contatos-DeleteContacts">
      <h2>{{ $t("title.contacts") }} - {{ $t("title.delete_contact") }}</h2>
      <p>{{ $t("contacts.delete_contact_method") }}</p>
      <div class="">
        <div class="delete type">DELETE</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/contacts</code></pre>
      </div>

      <div class="code-toggle">
        <button
          @click="selectedTab = 'json'"
          :class="{ active: selectedTab === 'json' }"
        >
          JSON
        </button>
        <button
          @click="selectedTab = 'curl'"
          :class="{ active: selectedTab === 'curl' }"
        >
          cURL
        </button>
      </div>
      <pre v-if="selectedTab === 'json'">
          <code class="language-json">{   
  "ids": [
    "3164512a-6f4a-46ff-9cdd-e14619001ad8",
    "3164512a-6f4a-46ff-9cdd-e14619001ad8"
  ]        
}</code>
        </pre>

      <pre v-if="selectedTab === 'curl'">
          <code class="language-bash">curl -XDELETE -H "Content-type: application/json" -d '{"ids":["3164512a-6f4a-46ff-9cdd-e14619001ad8"]}' 'https://{{ whitelabel?.api_domain }}/v1/contacts'
-u '[SEU ID]:[SEU TOKEN]'</code>
        </pre>
      <h3>{{ $t("general.header") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Content-Type</td>
            <td>String</td>
            <td>
              {{ $t("general.default_value") }}
              <span class="app-json">application/json</span>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ids</td>
            <td>Array</td>
            <td>{{ $t("table.contact_ids_to_be_deleted") }}</td>
          </tr>
        </tbody>
      </table>

      <button class="btn02">{{ $t("general.success") }}</button>
      <pre>
          <code class="language-json">HTTP/1.1 200 OK
{
  "message":"contato excluido"
}</code>
        </pre>

      <button class="btn02">Error-Response</button>
      <pre>
          <code class="language-json">{
    "error": "Error message"
  }</code>
        </pre>
    </section>

    <section id="api-Contatos-GetContactsId">
      <h2>
        {{ $t("title.contacts") }} - {{ $t("title.list_single_contact") }}
      </h2>
      <p>{{ $t("contacts.list_single_contact_method") }}</p>
      <div class="">
        <div class="get type">GET</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/contacts/:id</code></pre>
      </div>

      <div class="code-toggle">
        <button class="curl">cURL</button>
      </div>

      <pre>
          <code class="language-bash">curl -XGET -H "Content-type: application/json" 'https://{{ whitelabel?.api_domain }}/v1/contacts/945043d7-09d7-43a1-bb6b-b0e4cecee3ef'
-u '[SEU ID]:[SEU TOKEN]'</code>
        </pre>

      <h3>{{ $t("general.header") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Content-Type</td>
            <td>String</td>
            <td>
              {{ $t("general.default_value") }}
              <span class="app-json">application/json</span>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.contact_id") }}</td>
          </tr>
        </tbody>
      </table>

      <h3>Success 200</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>first_name</td>
            <td>String</td>
            <td>{{ $t("table.first_name_must") }}</td>
          </tr>
          <tr>
            <td>last_name</td>
            <td>String</td>
            <td>{{ $t("table.last_name_must") }}</td>
          </tr>
          <tr>
            <td>birthdate</td>
            <td>String</td>
            <td>{{ $t("table.birthdate") }}</td>
          </tr>
          <tr>
            <td>mobile_number</td>
            <td>String</td>
            <td>{{ $t("table.mobile_number_must") }}</td>
          </tr>
          <tr>
            <td>email</td>
            <td>String</td>
            <td>{{ $t("table.email_must") }}</td>
          </tr>
          <tr>
            <td>gender</td>
            <td>String</td>
            <td>{{ $t("table.gender") }}</td>
          </tr>
          <tr>
            <td>city</td>
            <td>String</td>
            <td>{{ $t("table.city") }}</td>
          </tr>
          <tr>
            <td>country</td>
            <td>String</td>
            <td>{{ $t("table.country") }}</td>
          </tr>
          <tr>
            <td>description</td>
            <td>String</td>
            <td>{{ $t("table.description-contact") }}</td>
          </tr>
          <tr>
            <td>account_id</td>
            <td>String</td>
            <td>{{ $t("account.account_id") }}</td>
          </tr>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.contact_id") }}</td>
          </tr>
          <tr>
            <td>created_at</td>
            <td>String</td>
            <td>{{ $t("table.created_at") }}</td>
          </tr>
          <tr>
            <td>updated_at</td>
            <td>String</td>
            <td>{{ $t("table.updated_at") }}</td>
          </tr>
          <tr>
            <td>groups</td>
            <td>Array</td>
            <td>{{ $t("table.groups_must") }}</td>
          </tr>
          <tr>
            <td>custom_fields</td>
            <td>Array</td>
            <td>{{ $t("general.custom_fields_list") }}</td>
          </tr>
        </tbody>
      </table>

      <button class="btn02">{{ $t("general.success") }}</button>
      <pre>
          <code class="language-json">HTTP/1.1 200 OK
{      
  "id": "945043d7-09d7-43a1-bb6b-b0e4cecee3ef",
  "first_name": "Nome",
  "last_name": "Sobrenome",
  "birthdate": null,
  "mobile_number": "999999999",
  "email": "",
  "gender": null,
  "city": null,
  "country": null,
  "description": null,
  "account_id": "f18c24ad-8339-4c4f-a2e8-143f27420f58",
  "created_at": "2020-08-04T13:29:58.000000Z",
  "updated_at": "2020-08-04T13:29:58.000000Z",
  "groups": [],
  "custom_fields": [
    {
      "id": "7d3fcc20-47c4-4848-82d7-872efeb60e77",
      "account_id": "52867698-ac7b-4186-a7e9-8525161c8b7f",
      "name": "CPF",
      "value": "12345678910",
      "description": "",
      "created_at": "2024-07-01T17:17:37.000000Z",
      "updated_at": "2024-07-01T17:17:37.000000Z",
      "deleted": false,
      "required_field": false,
      "sensitive_content": false,
      "appears_omni": true
    },
    {
      "id": "adcf43c2-4ce8-4fde-b979-07b14fb6de18",
      "account_id": "52867698-ac7b-4186-a7e9-8525161c8b7f",
      "name": "Tipo de serviço",
      "value": "teste",
      "description": "",
      "created_at": "2024-07-01T17:17:37.000000Z",
      "updated_at": "2024-07-01T17:17:37.000000Z",
      "deleted": false,
      "required_field": false,
      "sensitive_content": false,
      "appears_omni": true
    }
  ]
}</code>
        </pre>

      <button class="btn02">Error-Response</button>
      <pre>
          <code class="language-json">{
  "error": "Error message"
}</code>
        </pre>
    </section>

    <section id="api-Contatos-GetContacts">
      <h2>{{ $t("title.contacts") }} - {{ $t("title.list_contacts") }}</h2>
      <p>{{ $t("contacts.list_contacts_method") }}</p>
      <div class="">
        <div class="get type">GET</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/contacts</code></pre>
      </div>

      <div class="code-toggle">
        <button class="curl">cURL</button>
      </div>

      <pre v-if="selectedTab === 'curl'">
          <code class="language-bash">curl -XGET -H "Content-type: application/json" 'https://{{ whitelabel?.api_domain }}/v1/contacts'
-u '[SEU ID]:[SEU TOKEN]'</code>
        </pre>

      <h3>{{ $t("general.header") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Content-Type</td>
            <td>String</td>
            <td>
              {{ $t("general.default_value") }}
              <span class="app-json">application/json</span>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>Success 200</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>first_name</td>
            <td>String</td>
            <td>{{ $t("table.first_name_must") }}</td>
          </tr>
          <tr>
            <td>last_name</td>
            <td>String</td>
            <td>{{ $t("table.last_name_must") }}</td>
          </tr>
          <tr>
            <td>birthdate</td>
            <td>String</td>
            <td>{{ $t("table.birthdate") }}</td>
          </tr>
          <tr>
            <td>mobile_number</td>
            <td>String</td>
            <td>{{ $t("table.mobile_number_must") }}</td>
          </tr>
          <tr>
            <td>email</td>
            <td>String</td>
            <td>{{ $t("table.email_must") }}</td>
          </tr>
          <tr>
            <td>gender</td>
            <td>String</td>
            <td>{{ $t("table.gender") }}</td>
          </tr>
          <tr>
            <td>city</td>
            <td>String</td>
            <td>{{ $t("table.city") }}</td>
          </tr>
          <tr>
            <td>country</td>
            <td>String</td>
            <td>{{ $t("table.country") }}</td>
          </tr>
          <tr>
            <td>description</td>
            <td>String</td>
            <td>{{ $t("table.description-contact") }}</td>
          </tr>
          <tr>
            <td>account_id</td>
            <td>String</td>
            <td>{{ $t("table.account_id_create") }}</td>
          </tr>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.contact_id") }}</td>
          </tr>
          <tr>
            <td>created_at</td>
            <td>String</td>
            <td>{{ $t("table.created_at") }}</td>
          </tr>
          <tr>
            <td>updated_at</td>
            <td>String</td>
            <td>{{ $t("table.updated_at") }}</td>
          </tr>
          <tr>
            <td>groups</td>
            <td>Array</td>
            <td>{{ $t("table.groups_must") }}</td>
          </tr>
          <tr>
            <td>custom_fields</td>
            <td>Array</td>
            <td>{{ $t("general.custom_fields_list") }}</td>
          </tr>
        </tbody>
      </table>

      <button class="btn02">{{ $t("general.success") }}</button>
      <pre>
          <code class="language-json">HTTP/1.1 200 OK
{
  "data": [
    {      
      "id": "3164512a-6f4a-46ff-9cdd-e14619001ad8",
      "first_name": "Nome",
      "last_name": "Sobrenome",
      "birthdate": null,
      "mobile_number": "999999999",
      "email": "",
      "gender": null,
      "city": null,
      "country": null,
      "description": null,
      "account_id": "f18c24ad-8339-4c4f-a2e8-143f27420f58",
      "created_at": "2020-08-04T13:29:58.000000Z",
      "updated_at": "2020-08-04T13:29:58.000000Z",
      "groups": [],
      "custom_fields": [
        {
          "id": "7d3fcc20-47c4-4848-82d7-872efeb60e77",
          "account_id": "52867698-ac7b-4186-a7e9-8525161c8b7f",
          "name": "CPF",
          "value": "12345678910",
          "description": "",
          "created_at": "2024-07-01T17:17:37.000000Z",
          "updated_at": "2024-07-01T17:17:37.000000Z",
          "deleted": false,
          "required_field": false,
          "sensitive_content": false,
          "appears_omni": true
        },
        {
          "id": "adcf43c2-4ce8-4fde-b979-07b14fb6de18",
          "account_id": "52867698-ac7b-4186-a7e9-8525161c8b7f",
          "name": "Tipo de serviço",
          "value": "teste",
          "description": "",
          "created_at": "2024-07-01T17:17:37.000000Z",
          "updated_at": "2024-07-01T17:17:37.000000Z",
          "deleted": false,
          "required_field": false,
          "sensitive_content": false,
          "appears_omni": true
        }
      ]
    }
  ]
}</code>
        </pre>

      <button class="btn02">{{ $t("general.returned_statuses") }}</button>
      <pre>
          <code class="language-bash">{
  "error": "Error message"
}</code></pre>
    </section>
  </section>
</template>

<script>
import hljs from "highlight.js";
import "highlight.js/styles/an-old-hope.css";

export default {
  name: "SmsComponent",
  data() {
    return {
      selectedTab: "json",
    };
  },
  mounted() {
    this.highlightCode();
  },
  watch: {
    selectedTab() {
      this.$nextTick(() => {
        this.highlightCode();
      });
    },
  },
  methods: {
    highlightCode() {
      document.querySelectorAll("pre code").forEach((block) => {
        hljs.highlightBlock(block);
      });
    },
  },
};
</script>

<style scoped>
.sms-method {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1rem;
}

pre[class*="language-"] {
  background-color: #000 !important;
  color: var(--green-code);
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  overflow-x: auto;
  white-space: pre-wrap;
  font-family: var(--font-code);
  margin-bottom: 20px;
}
</style>
